import React, {FC, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import styles from './LeftPanel.module.scss'
import {GetRmsChatList, getRmsChat} from '../../../inbox-v2/InboxSlice/InboxSlice'

interface RmsConversation {
  rmsThreadKey: string
  subscriberNumber: string
  message: string
  fields?: Array<Array<{name: string; value: string}>>
}

interface RmsConversationListProps {
  selectedId: string | null
  onSelect: (conversation: RmsConversation) => void
}

const RmsConversationList: FC<RmsConversationListProps> = ({selectedId, onSelect}) => {
  const dispatch = useDispatch()
  const rmsMessageData: RmsConversation[] = useSelector(getRmsChat) || []

  useEffect(() => {
    // Fetch RMS chat list on mount
    dispatch(GetRmsChatList({}))
  }, [dispatch])

  // Get display name from fields
  const getDisplayName = (conversation: RmsConversation): string => {
    if (!conversation.fields?.[0]) return conversation.subscriberNumber

    const nameField = conversation.fields[0].find((field) => {
      const fieldName = field?.name?.toLowerCase()?.replace(/ +/g, '')
      return fieldName === 'firstname' || fieldName === 'lastname' || fieldName === 'fullname'
    })

    return nameField?.value || conversation.subscriberNumber
  }

  // Get initials for avatar
  const getInitials = (name: string): string => {
    if (!name) return '-'
    const parts = name.trim().split(' ')
    if (parts.length >= 2) {
      return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase()
    }
    return name.charAt(0).toUpperCase()
  }

  if (rmsMessageData.length === 0) {
    return (
      <div className={styles.emptyList}>
        <i className='bi bi-chat-dots'></i>
        <p>No RMS conversations found</p>
      </div>
    )
  }

  return (
    <>
      {rmsMessageData.map((conversation, index) => {
        const displayName = getDisplayName(conversation)
        const isActive = selectedId === conversation.rmsThreadKey

        return (
          <div
            key={conversation.rmsThreadKey || index}
            className={`${styles.rmsConversationItem} ${isActive ? styles.active : ''}`}
            onClick={() => onSelect(conversation)}
          >
            <div className={styles.rmsAvatar}>{getInitials(displayName)}</div>
            <div className={styles.rmsContent}>
              <div className={styles.rmsName}>{displayName}</div>
              <div className={styles.rmsMessage}>{conversation.message}</div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default RmsConversationList